import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto,
} from '../../services/wealthlane-award-services';

const useGetDashboardUpcomingEvents = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto> | undefined,
  unknown
> => {
  const dashboardUpcomingEvents = useQuery(['getDashboardUpcomingEvents'], async () => {
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardUpcomingEvents());
  });

  return dashboardUpcomingEvents;
};

export default useGetDashboardUpcomingEvents;
